import { IBaseSurveyEntry } from './IBaseSurveyEntry';
import { SurveyTypes } from '../../services/SurveyService';
import { ICustomSurveyQuestion } from './ICustomSurveyQuestion';

export interface ICustomSurveyEntry extends IBaseSurveyEntry {
  customFont?: string;
  progressBar: boolean;
  introDisabled: boolean;
  outroDisabled: boolean;
  type: 'CUSTOMSURVEY';
  questions?: ICustomSurveyQuestion[];
}

export const isCustomSurvey = (survey: SurveyTypes): survey is ICustomSurveyEntry => {
  return survey.type === 'CUSTOMSURVEY';
};
